import React, { Component } from 'react';
import { initConfigurator, setOutriggersValue } from '../modules/config';
import { Button, Progress } from 'semantic-ui-react';
import { createOrder } from '../modules/helper';

export default class Player extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processPercent: undefined,
      api: null,
      initConfig: null,
      // load: false,
    };
  }
  componentDidMount() {
    const { product, setAppState, initConfig } = this.props;
    const api = window.claraplayer(document.getElementById('player-root'));
    window.api = api;
    api.sceneIO.fetchAndUse(product.sceneId, product.publishedHash);
    if (
      initConfig['Outriggers & Infills- Closed Frame'] ||
      initConfig['Outriggers & Infills- Open Frame']
    ) {
      const value = initConfig['Outriggers & Infills- Closed Frame']
        ? initConfig['Outriggers & Infills- Closed Frame']
        : initConfig['Outriggers & Infills- Open Frame'];
      setOutriggersValue(value.split(' ')[0]);
    }

    const frame =
      Object.keys(initConfig).length > 0
        ? { 'Frame Type': initConfig['Frame Type'] }
        : {};
    if (Object.keys(initConfig).length > 0 && initConfig['Frame Type'])
      delete initConfig['Frame Type'];
    api.on('loaded', () => {
      initConfigurator(api, product.sceneId, {
        form: product.form,
        configuration: {},
      }).then(() => {
        api.configuration.setConfiguration(frame);
        if (Object.keys(initConfig).length > 0)
          api.configuration.setConfiguration(initConfig);

        const initConfiguration =
          Object.keys(initConfig).length > 0
            ? initConfig
            : api.configuration.getConfiguration();
        this.setState({
          initConfig: initConfiguration,
          api: api,
        });
        setAppState({
          api,
          loaded: true,
        });
      });
      // console.log(product);
      // api.configuration.onChange = product.configOnchange;
    });
  }

  render() {
    return (
      <div className="player-side">
        <div id="player-root" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Player.js